import GroupTopStories from './group-top-stories'

export default GroupTopStories
